import gql from 'graphql-tag';
export const publicAppSearchQuery = gql `
  query publicAppSearchQuery(
    $nameContains: String!
    $limit: Int!
    $excludeUpcoming: Boolean
    $includeIsAppAdmin: Boolean
    $includeIsAppCollaborator: Boolean
  ) {
    getAppsByNameContains(
      nameContains: $nameContains
      limit: $limit
      excludeUpcoming: $excludeUpcoming
      includingIsAppAdmin: $includeIsAppAdmin
      includingIsAppCollaborator: $includeIsAppCollaborator
    ) {
      edges {
        id
        canonicalId
        slug
        name
        currentImplementation {
          id
        }
        images {
          url_16x16
          url_32x32
          url_64x64
          url_128x128
        }
      }
    }
  }
`;
//# sourceMappingURL=publicAppSearchQuery.js.map
// @zapier/design-system@5.32.5 (2004a9d50)
